import { Tooltip, Typography } from "antd";
import {
  addListContact,
  deleteAssetAudience,
  deleteCampaignAudience,
  linkAudienceWithAsset,
  linkAudienceWithCampaign,
} from "modules/Campaigns/Audience/actions";
import { deleteProfiledContactFromList } from "modules/Campaigns/Audience/Lists/actions";
import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store";
import styled from "styled-components";
import AddIcon from "../../../assets/img/icons/addicon.svg";
import MinusIcon from "../../../assets/img/icons/minusIcon.svg";
import xiqPlaceholderImage from "../../../assets/img/xiqPlaceholder.jpg";
import { getScheduledEmails, setScheduledEmailModalOpen } from "modules/Audience/Actions/listsActions";

interface IRecommendedCardProps {
  contactId?: number;
  assetId?: number;
  campaignId?: number;
  listId?: number;
  title?: string;
  imgUrl?: string;
  imgUrlTwo?: string;
  imgUrlThree?: string;
  company?: string;
  keywords?: string[];
  stylev1?: boolean;
  add?: boolean;
  isList?: boolean;
  unsubscribed?: boolean;
  subscribed_assetId?: number;
  subscribed_campaignId?: number;
  subscribed_listId?: number;
  minusIcon?: boolean;
  isProfiled?: boolean;
  index?: number;
  inDetailProfile?: boolean;
}

const RecommendedCard: React.FC<IRecommendedCardProps> = (props) => {
  const {
    assetId,
    campaignId,
    listId,
    subscribed_assetId,
    subscribed_campaignId,
    subscribed_listId,
    minusIcon,
    isProfiled,
    index,
    inDetailProfile,
  } = props;
  const contactId = props?.contactId ? props.contactId : parseInt("");
  // selected contacts
  const [ellipsisState, setEllipsistate] = useState(false);
  const { Paragraph } = Typography;

  const contactDashboardCampaingsLength: number = useSelector(
    (state: RootState) => state.peopleAudience?.contactDashboard?.assets?.length
  );
  const contactDashboardListsLength: number = useSelector(
    (state: RootState) => state.peopleAudience?.contactDashboard?.lists?.length
  );

  const linkAudience = (
    selectedListIds: number[],
    selectedContactIds: number[],
    assetId?: number,
    campaignId?: number,
    listId?: number
  ) => {
    if (selectedListIds.length > 0 || selectedContactIds.length > 0) {
      if (assetId) {
        // console.log("asset selected");
        linkAudienceWithAsset(
          assetId,
          selectedListIds,
          selectedContactIds,
          index,
          true,
          contactDashboardCampaingsLength
        );
        // dispatch action to remove asset item from reducer in contact sidebar Dashboard tab
      } else if (campaignId) {
        // console.log("campaign selected");
        linkAudienceWithCampaign(campaignId, selectedListIds, selectedContactIds, index);
        // dispatch action to remove campaign item from reducer in contact sidebar Dashboard tab
      } else if (listId) {
        // console.log("list selected");
        getScheduledEmails(listId).then((res) => {
          if (res) {
            setScheduledEmailModalOpen(true);
          } else {
            addListContact(listId.toString(), contactId.toString(), index, true, contactDashboardListsLength);
          }
        })
        // dispatch action to remove list item from reducer in contact sidebar Dashboard tab
      }
    }
  };

  const removeAudience = (
    selectedListIds: number[],
    selectedContactIds: number[],
    subscribed_assetId?: number,
    subscribed_campaignId?: number,
    subscribed_listId?: number
  ) => {
    if (subscribed_assetId) {
      // console.log("subscribed asset selected");
      deleteAssetAudience(selectedListIds, selectedContactIds, subscribed_assetId.toString(), index);
    } else if (subscribed_campaignId) {
      // console.log("subscribed campaign selected");
      deleteCampaignAudience(selectedListIds, selectedContactIds, subscribed_campaignId.toString(), index);
    } else if (subscribed_listId && isProfiled) {
      // console.log("subscribed list selected for profiled");
      deleteProfiledContactFromList(selectedContactIds, false, subscribed_listId, inDetailProfile);
    } else if (subscribed_listId && !isProfiled) {
      // console.log("subscribed list selected for non profiled");
    }
  };

  return (
    <>
      <RecommendedCardItem>
        <div className="wrapper">
          <div className="content-div">
            <div className="blog-image">
              {props.stylev1 ? (
                <span className="start-bar"></span>
              ) : (
                <span className="start-bar start-bar-white"></span>
              )}

              <img
                src={props.imgUrl === "" ? xiqPlaceholderImage : props.imgUrl}
                alt=""
                className="imageOne"
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = xiqPlaceholderImage;
                }}
              />
              <img
                src={props.imgUrlTwo === "" ? xiqPlaceholderImage : props.imgUrlTwo}
                alt=""
                className="imageTwo"
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = xiqPlaceholderImage;
                }}
              />
              <img
                src={props.imgUrlThree === "" ? xiqPlaceholderImage : props.imgUrlThree}
                alt=""
                className="imageThree"
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = xiqPlaceholderImage;
                }}
              />
            </div>
            <div className="content padding-right-lg padding-left-md">
              <h4 className="title">
                <Tooltip placement="top" title={ellipsisState ? props?.title : undefined}>
                  <Paragraph className="paragraph-styling" ellipsis={{ rows: 2, onEllipsis: setEllipsistate }}>
                    <>{props?.title}</>
                  </Paragraph>
                </Tooltip>
              </h4>
              {/* {(!props.keywords && props.company && !props.isList) || true ? (
                <p className="company">{props.company}</p>
              ) : (
                props.keywords && <p className="keywords">{props.keywords.join(", ")}</p>
              )} */}
            </div>
            {!props.unsubscribed && props.add ? (
              <div className="Blog-menu-icon text-right">
                <div className="padding-sm padding-top-xs padding-bottom-xs">
                  {minusIcon === true ? (
                    <img
                      style={{ opacity: 0, pointerEvents: "none" }} // hide icon temporarily
                      onClick={() =>
                        removeAudience(
                          [],
                          [contactId],
                          subscribed_assetId,
                          subscribed_campaignId,
                          subscribed_listId
                        )
                      }
                      src={MinusIcon}
                      alt="menu"
                    />
                  ) : (
                    <img
                      onClick={() => linkAudience([], [contactId], assetId, campaignId, listId)}
                      style={{ cursor: "pointer" }}
                      src={AddIcon}
                      alt="menu"
                    />
                  )}
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </RecommendedCardItem>
    </>
  );
};
export default RecommendedCard;

RecommendedCard.defaultProps = {
  imgUrl:
    "https://image.freepik.com/free-photo/abstract-surface-textures-white-concrete-stone-wall_74190-8184.jpg",
  imgUrlTwo:
    "https://image.freepik.com/free-photo/abstract-surface-textures-white-concrete-stone-wall_74190-8184.jpg",
  imgUrlThree:
    "https://image.freepik.com/free-photo/abstract-surface-textures-white-concrete-stone-wall_74190-8184.jpg",
  title: "Asset Name Goes Here",
  // company: "Campaign Name Goes Here",
  stylev1: true,
  add: true,
};

const RecommendedCardItem = styled.div`
  width: 100%;
  margin-bottom: 10px;
  clear: both;

  .paragraph-styling {
    overflow-wrap: normal;
    word-break: break-word;
  }
  .wrapper {
    background-color: #fff;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;
    position: relative;
    border-radius: 10px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      border-radius: 7px;
    }
    .add-icon {
      position: absolute;
      top: 10px;
      right: 10px;
    }
    .add-icon:hover {
      cursor: pointer;
    }
    .content-div {
      padding: 14px 22px;
      display: flex;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        padding: 10px 12px;
      }
      .Blog-menu-icon {
        margin-top: 35px;
        /* cursor: pointer; */
        .company-logo {
          cursor: default;
          margin-right: -20px;
          margin-bottom: -40px;
          img {
            max-width: 40px;
          }
        }
      }
      .content {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        flex-grow: 1;
        width: 100%;
        max-width: calc(100% - 155px);
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          max-width: calc(100% - 125px);
        }
      }
      .blog-image {
        position: relative;
        min-width: 110px;
        padding-top: 4px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          min-width: 80px;
        }
        .start-bar {
          background-color: #f1862e;
          border-radius: 3px 0 0 3px;
          border-right: 1px solid #fff;
          width: 6px;
          height: 62px;
          float: left;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            width: 5px;
            height: 45px;
            border-radius: 3px 0 0 3px;
          }
          &.start-bar-white {
            background-color: #fff;
          }
        }
        img {
          float: left;
          &.imageOne {
            width: 70px;
            height: 62px;
            border-right: 1px solid #fff;
            border-radius: 3px 0 0 3px;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              width: 50px;
              height: 45px;
              border-radius: 2px 0 0 2px;
            }
          }
          &.imageTwo {
            width: 31px;
            height: 31px;
            border-bottom: 1px solid #fff;
            border-radius: 0 3px 0;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              width: 22px;
              height: 22px;
              border-radius: 0 2px 0;
            }
          }
          &.imageThree {
            width: 31px;
            height: 31px;
            border-radius: 0 0 3px 0;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              width: 22px;
              height: 23px;
              border-radius: 0 0 2px 0;
            }
          }
        }
        .banner-left-icons {
          display: flex;
          position: absolute;
          top: 0.6em;
          left: 0.5em;
          justify-content: flex-start;
          img {
            height: 20px;
            width: 20px;
          }
        }
      }
      .Blog-menu-icon {
        margin-top: 15px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          margin-top: 10px;
        }
        img {
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            width: 22px;
          }
        }
      }
      .content {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        flex-grow: 1;
        width: 100%;
        .title {
          font-family: "Roboto Slab", serif;
          font-size: 22px;
          color: #424b50;
          margin: 0;
          padding: 0;
          min-height: 52px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 26px;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            font-size: 13px;
            line-height: 17px;
            min-height: 32px;
          }
          p,
          div.ant-typography {
            margin: 0;
          }
        }
        .company {
          color: #27ce0a;
          font-size: 12px;
          font-weight: 500;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-bottom: 0;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            font-size: 9px;
          }
        }
        .keywords {
          color: #7e7e7e;
          font-size: 12px;
          font-weight: 500;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-bottom: 0;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            font-size: 9px;
          }
        }
        .Blog-menu-icon img {
          cursor: pointer;
          .ant-popover .ant-popover-content .ant-popover-inner {
            border-radius: 10px;
          }
        }
      }
    }
  }
`;
